import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faq } from '../data/faq';
import { CTAButton } from './CTAButton';
export function FAQ() {
  return <section className="border-y border-sage/30 bg-cream-dark px-4 py-8" data-id="element-36" data-mp="1mal24z81vmrz">
      <div className="mx-auto max-w-3xl" data-id="element-37" data-mp="1he2yk2oghuh8">
        <h2 className="text-center font-display text-2xl font-black uppercase leading-tight sm:text-3xl" data-id="element-38" data-mp="1cei3428hw499">
          Domande frequenti
        </h2>

        <div className="mt-4 space-y-2" data-id="element-39" data-mp="2a0xk72x0ezwa">
          {faq.map((item, index) => <details key={item.question} open={index === 0} className="group rounded-xl border border-sage/40 bg-white px-4 py-3" data-id="element-40" data-mp="252vw23kq8ady" data-mpi={index}>
              <summary className="flex cursor-pointer list-none items-center justify-between gap-3 font-display text-sm font-extrabold uppercase leading-tight text-petrol sm:text-base" data-id="element-41" data-mp="1v5hkah9r09rz">
                {item.question}
                <ChevronDownIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-open:rotate-180" aria-hidden="true" data-id="element-42" data-mp="jorhz98g423n" />
              </summary>
              <div className="mt-1.5 space-y-1 text-[13px] leading-snug text-graphite sm:text-sm" data-id="element-43" data-mp="1pm1tbuz37wlp">
                {item.answer.map(line => <p key={line} data-id="element-44" data-mp="1fodm45kaowmn">{line}</p>)}
              </div>
            </details>)}
        </div>

        <CTAButton className="mx-auto mt-5 max-w-lg" data-id="element-45" data-mp="11w7fpb6y240e" />
      </div>
    </section>;
}